import { sendGet, sendPost } from "@/api/base";
import { getAPIData } from "../helpers";
import {
  LoginRequest,
  RefreshTokenRequest,
  RegisterRequest,
  ResetPassword,
  CreateWorkspace,
  StoreLoginRequest,
  StoreConnect,
} from "./types";

export const login = (params: LoginRequest) =>
  getAPIData(sendPost("auth/login/", params));

export const storeLogin = (params: StoreLoginRequest) =>
  getAPIData(sendPost("shopify/login/", params));

export const register = (params: RegisterRequest) =>
  getAPIData(sendPost("auth/register/", params));

export const getUser = () => getAPIData(sendGet("auth/user/"));

export const getUserWorkspaces = () => getAPIData(sendGet("workspace/list/"));

export const createWorkspace = (params: CreateWorkspace) =>
  getAPIData(sendPost("workspace/create/", params));

export const resetPasswordEmail = (params: Omit<LoginRequest, "password">) =>
  getAPIData(sendPost("auth/forget_password/", params));

export const resetPassword = (params: ResetPassword) =>
  getAPIData(sendPost("auth/reset_password/", params));

export const refreshToken = (params: RefreshTokenRequest) =>
  sendPost("auth/token/refresh/", params);

export const logout = () => getAPIData(sendPost("auth/logout/", {}));

export const storeConnect = (params: StoreConnect) =>
  getAPIData(sendPost("connect/shopify/", params));